import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from '@chakra-ui/react';
import { ChevronRightIcon } from 'lucide-react';
import { FC } from 'react';

interface ComplianceReviewBreadcrumbProps {
  /** The property/folder label for the root crumb (tapping it returns to the overview). */
  propertyLabel: string;
  /** The selected document's name for the current (non-link) crumb. */
  documentName?: string | null;
  /** Returns to the overview (drops the `?documentId=` selection). */
  onBack: () => void;
}

/**
 * Mobile-only breadcrumb shown above the document detail. The single-pane
 * mobile flow replaces the desktop left rail when a document is open, so this
 * gives the agent both their place in the hierarchy (property → document) and
 * the way back: tapping the property crumb clears the selection and returns to
 * the overview.
 */
export const ComplianceReviewBreadcrumb: FC<
  ComplianceReviewBreadcrumbProps
> = ({ propertyLabel, documentName, onBack }) => (
  <Breadcrumb
    color="compliance.text.primary"
    fontSize="sm"
    separator={<ChevronRightIcon size={14} />}
    spacing={2}
    sx={{ '& ol': { flexWrap: 'nowrap' } }}
  >
    <BreadcrumbItem overflow="hidden">
      <BreadcrumbLink
        as="button"
        color="compliance.text.muted"
        maxW="160px"
        overflow="hidden"
        textAlign="left"
        textOverflow="ellipsis"
        type="button"
        whiteSpace="nowrap"
        onClick={onBack}
      >
        {propertyLabel}
      </BreadcrumbLink>
    </BreadcrumbItem>

    <BreadcrumbItem isCurrentPage overflow="hidden">
      <Text
        as="span"
        color="compliance.text.primary"
        fontWeight="medium"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {documentName}
      </Text>
    </BreadcrumbItem>
  </Breadcrumb>
);
